<template>
<div class="u-flexcl-h100"  style="height: calc(100% - 5rem);" :class="{ 'actionBuilderOrderSummary--loading': loading }">
    <v-runtime-template v-if="template" :template="template" />
    <div v-else style="flex: 1">
        <ul>
            <li v-for="(error, index) in errors" :key="`error_${index}`" v-html="error"></li>
        </ul>
    </div>

    <div class="actionBuilderOrderSummary__loadingCtn">
        <div class="actionBuilderOrderSummary__loading"><img src="/img/loading.gif"></div>
    </div>
</div>
</template>



<script>
import VRuntimeTemplate from 'v-runtime-template'
import EventBus from '../../EventBus.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'ActionBuilderOrderSummary',

    components: {
        VRuntimeTemplate,
    },

    props: {
    },

    data() {
        return {
            hasForm: document.querySelector('#action-builder-form'),
            loading: false,
            template: '',
            errors: [],
        }
    },




    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        EventBus.$on('actionbuilder-update', (data) => {
            this.loadHtml(data.method)
        })
    },


    mounted() {
        this.loadHtml('GET')
        this.bindEvents()
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        loadHtml(method) {
            if (!this.hasForm) {
                return
            }
            this.loading = true

            const form = document.querySelector('#action-builder-form')
            const url = form.getAttribute('action')

            const formData = new FormData(form)

            const errorMessageElements = form.querySelectorAll('.formError[data-errorkey]')
            const errorFieldElements = form.querySelectorAll('.formInput[data-errorkey]')

            const h = new Headers()
            h.append('X-Requested-With', 'XMLHttpRequest')

            let options = {}
            switch (method) {
                case 'POST':
                    // clear errors
                    errorMessageElements.forEach((el) => {
                        el.innerHTML = ''
                    })
                    errorFieldElements.forEach((el) => {
                        el.classList.remove('has-error')
                    })

                    options = {
                        method: 'POST',
                        headers: h,
                        body: formData,
                    }
                    break

                default:
                    h.append('Cache-Control', 'no-store')
                    h.append('Pragma', 'no-cache')
                    h.append('Expires', '0')

                    options = {
                        method: 'GET',
                        headers: h,
                    }
                    break
            }

            fetch(url, options)
                .then(response => response.text())
                .then((html) => {
                    this.loading = false
                    document.querySelector('.actionBuilder__maincol').classList.remove('actionBuilderOrderSummary--loading') // content part loading
                    // if response is json, it means we have an error. @todo : handle
                    if (html[0] === '{') {
                        // parse json from laravel validation and save it in this.errors array, json.errors is an object, we need an array
                        const json = JSON.parse(html)
                        if (Object.prototype.hasOwnProperty.call(json, 'errors')) {
                            this.errors = Object.keys(json.errors).map(key => json.errors[key][0])

                            // display error on form
                            Object.entries(json.errors).forEach(([errorKey, errorValues]) => {
                                const errorMessageElement = form.querySelector(`.formError[data-errorkey="${errorKey}"]`)
                                const errorFieldElement = form.querySelector(`.formInput[data-errorkey="${errorKey}"]`)
                                if (errorMessageElement) {
                                    errorMessageElement.innerHTML = errorValues.join('<br>')
                                }
                                if (errorFieldElement) {
                                    errorFieldElement.classList.add('has-error')
                                }
                            })
                        }
                        return
                    }

                    this.template = html
                    this.$nextTick(() => {
                        setTimeout(() => APP.Layout.initComps(), 0)
                    })
                })
        },

        bindEvents() {
            // Listen change event on .js-ab-update-on-change elements
            const form = document.querySelector('#action-builder-form')
            
            form.addEventListener('change', () => {
                // if form has data-no-post, we don't want to update on change
                if (form.hasAttribute('data-no-post')) {
                    return
                }
                EventBus.$emit('actionbuilder-update', { method: 'POST' })
            })
            // const els = document.querySelectorAll('.js-ab-update-on-change input, .js-ab-update-on-change select')
            // els.forEach((el) => {
            //     el.addEventListener('change', () => {
            //         EventBus.$emit('actionbuilder-update', { method: 'POST' })
            //     })
            // })

            // Listen for click on ab-final-submit-btn
            const finalSubmitBtn = document.querySelector('.js-ab-final-submit-btn')
            if (finalSubmitBtn) {
                finalSubmitBtn.addEventListener('click', (e) => {
                    e.preventDefault()
                    EventBus.$emit('confirm-modal-open', {
                        title: finalSubmitBtn.getAttribute('data-title'),
                        text: finalSubmitBtn.getAttribute('data-text'),
                        confirmBtnLabel: finalSubmitBtn.getAttribute('data-confirm-btn-label'),
                        cancelBtnLabel: finalSubmitBtn.getAttribute('data-cancel-btn-label'),
                        closable: true,
                        callback: () => {
                            document.querySelector('#cart-form').submit()
                        },
                        cancelCallback: () => {
                            document.querySelector('#cart-form').querySelector('input[name="redirect"]').value = 'restart'
                            document.querySelector('#cart-form').submit()
                        },
                    })
                })
            }
        },
    },


}

</script>
